import { lazy } from 'react';

export const CertificatesPage = lazy(() => import('./CertificatesPage'));
